import { cn } from "@/lib/utils";
import { InfoTip } from "@/components/InfoTip";

const ACCENT = {
  good: "152 66% 42%",
  warn: "32 95% 50%",
  bad: "0 84% 58%",
  neutral: "214 90% 52%",
};

export const KpiCard = ({ label, value, sub, icon: Icon, tone = "neutral", testId, className, style, info }) => {
  const accent = ACCENT[tone] || ACCENT.neutral;
  const valueColor = {
    good: "text-emerald-600",
    warn: "text-amber-600",
    bad: "text-red-600",
    neutral: "text-foreground",
  }[tone];

  return (
    <div
      data-testid={testId}
      style={style}
      className={cn(
        "group relative overflow-hidden rounded-xl border border-border bg-card p-5 card-elevated transition-all duration-300 hover:-translate-y-1 hover:shadow-lg",
        className
      )}
    >
      <span className="absolute inset-x-0 top-0 h-[3px]" style={{ background: `hsl(${accent})` }} />
      <div
        className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full opacity-0 blur-2xl transition-opacity duration-300 group-hover:opacity-100"
        style={{ background: `hsl(${accent} / 0.18)` }}
      />
      <div className="flex items-start justify-between">
        <span className="flex items-center gap-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground">
          {label}
          {info ? <InfoTip text={info} /> : null}
        </span>
        {Icon ? (
          <div
            className="flex h-8 w-8 items-center justify-center rounded-lg"
            style={{ background: `hsl(${accent} / 0.12)`, color: `hsl(${accent})` }}
          >
            <Icon className="h-4 w-4" strokeWidth={2} />
          </div>
        ) : null}
      </div>
      <div className="mt-5">
        <div className={cn("font-mono text-[28px] font-semibold leading-none tracking-tight", valueColor)}>{value}</div>
        {sub ? <div className="mt-2 text-xs text-muted-foreground">{sub}</div> : null}
      </div>
    </div>
  );
};
